import { legacy_createStore as createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer from "../redux/rootReducer";
import { injectTokenInterceptor } from '../helpers/apicalls/interceptor';
const persistConfig = {
  key: "authType",
  version: 1,
  storage: storage,
  whitelist: ["VisitorReducer"] // which reducer want to store
  //Auth reducer save 
};
const pReducer = persistReducer(persistConfig, rootReducer);
const middleware = applyMiddleware(thunk);
const store = createStore(pReducer, middleware);
const persistor = persistStore(store);
injectTokenInterceptor(store);

export { persistor, store };
